const ACTION_PREFIX = '@@app/meetings'
const makeConstant = constant => `${ACTION_PREFIX}/${constant}`

export const GOOGLE_OAUTH_ACCEPT = makeConstant('GOOGLE_OAUTH_ACCEPT')
export const GOOGLE_OAUTH_ACCEPT_SUCCESS = makeConstant('GOOGLE_OAUTH_ACCEPT_SUCCESS')
export const GOOGLE_OAUTH_ACCEPT_FAILURE = makeConstant('GOOGLE_OAUTH_ACCEPT_FAILURE')

export const MICROSOFT_OAUTH_ACCEPT = makeConstant('MICROSOFT_OAUTH_ACCEPT')
export const MICROSOFT_OAUTH_ACCEPT_SUCCESS = makeConstant('MICROSOFT_OAUTH_ACCEPT_SUCCESS')
export const MICROSOFT_OAUTH_ACCEPT_FAILURE = makeConstant('MICROSOFT_OAUTH_ACCEPT_FAILURE')

export const FETCH_CALENDAR_STATUS = makeConstant('FETCH_CALENDAR_STATUS')
export const FETCH_CALENDAR_STATUS_PENDING = makeConstant('FETCH_CALENDAR_STATUS_PENDING')
export const FETCH_CALENDAR_STATUS_SUCCESS = makeConstant('FETCH_CALENDAR_STATUS_SUCCESS')
export const FETCH_CALENDAR_STATUS_FAILURE = makeConstant('FETCH_CALENDAR_STATUS_FAILURE')

export const FETCH_MICROSOFT_CALENDARS = makeConstant('FETCH_MICROSOFT_CALENDARS')
export const FETCH_MICROSOFT_CALENDARS_PENDING = makeConstant('FETCH_MICROSOFT_CALENDARS_PENDING')
export const FETCH_MICROSOFT_CALENDARS_SUCCESS = makeConstant('FETCH_MICROSOFT_CALENDARS_SUCCESS')
export const FETCH_MICROSOFT_CALENDARS_FAILURE = makeConstant('FETCH_MICROSOFT_CALENDARS_FAILURE')

export const FETCH_MICROSOFT_ADMIN_CONSENT = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT')
export const FETCH_MICROSOFT_ADMIN_CONSENT_PENDING = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT_PENDING')
export const FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS')
export const FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE')

export const FETCH_MICROSOFT_MANAGED_CALENDARS = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS')
export const FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING')
export const FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS')
export const FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE')

export const DISCONNECT_MICROSOFT_ADMIN_CONSENT = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT ')
export const DISCONNECT_MICROSOFT_ADMIN_CONSENT_PENDING = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT _PENDING')
export const DISCONNECT_MICROSOFT_ADMIN_CONSENT_SUCCESS = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT _SUCCESS')
export const DISCONNECT_MICROSOFT_ADMIN_CONSENT_FAILURE = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT _FAILURE')

export const MICROSOFT_ADMIN_MANAGED_ACCEPT = makeConstant('MICROSOFT_ADMIN_MANAGED_ACCEPT')
export const MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS = makeConstant('MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS')
export const MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE = makeConstant('MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE')

export const FETCH_GOOGLE_CALENDARS = makeConstant('FETCH_GOOGLE_CALENDARS')
export const FETCH_GOOGLE_CALENDARS_PENDING = makeConstant('FETCH_GOOGLE_CALENDARS_PENDING')
export const FETCH_GOOGLE_CALENDARS_SUCCESS = makeConstant('FETCH_GOOGLE_CALENDARS_SUCCESS')
export const FETCH_GOOGLE_CALENDARS_FAILURE = makeConstant('FETCH_GOOGLE_CALENDARS_FAILURE')

export const UPDATE_GOOGLE_CALENDAR = makeConstant('UPDATE_GOOGLE_CALENDAR')
export const UPDATE_GOOGLE_CALENDAR_PENDING = makeConstant('UPDATE_GOOGLE_CALENDAR_PENDING')
export const UPDATE_GOOGLE_CALENDAR_SUCCESS = makeConstant('UPDATE_GOOGLE_CALENDAR_SUCCESS')
export const UPDATE_GOOGLE_CALENDAR_FAILURE = makeConstant('UPDATE_GOOGLE_CALENDAR_FAILURE')

export const UPDATE_MICROSOFT_CALENDAR = makeConstant('UPDATE_MICROSOFT_CALENDAR')
export const UPDATE_MICROSOFT_CALENDAR_PENDING = makeConstant('UPDATE_MICROSOFT_CALENDAR_PENDING')
export const UPDATE_MICROSOFT_CALENDAR_SUCCESS = makeConstant('UPDATE_MICROSOFT_CALENDAR_SUCCESS')
export const UPDATE_MICROSOFT_CALENDAR_FAILURE = makeConstant('UPDATE_MICROSOFT_CALENDAR_FAILURE')

export const DISCONNECT_GOOGLE_CALENDAR = makeConstant('DISCONNECT_GOOGLE_CALENDAR')
export const DISCONNECT_GOOGLE_CALENDAR_PENDING = makeConstant('DISCONNECT_GOOGLE_CALENDAR_PENDING')
export const DISCONNECT_GOOGLE_CALENDAR_SUCCESS = makeConstant('DISCONNECT_GOOGLE_CALENDAR_SUCCESS')
export const DISCONNECT_GOOGLE_CALENDAR_FAILURE = makeConstant('DISCONNECT_GOOGLE_CALENDAR_FAILURE')

export const DISCONNECT_MICROSOFT_CALENDAR = makeConstant('DISCONNECT_MICROSOFT_CALENDAR')
export const DISCONNECT_MICROSOFT_CALENDAR_PENDING = makeConstant('DISCONNECT_MICROSOFT_CALENDAR_PENDING')
export const DISCONNECT_MICROSOFT_CALENDAR_SUCCESS = makeConstant('DISCONNECT_MICROSOFT_CALENDAR_SUCCESS')
export const DISCONNECT_MICROSOFT_CALENDAR_FAILURE = makeConstant('DISCONNECT_MICROSOFT_CALENDAR_FAILURE')

export const FETCH_GOOGLE_SCOPES = makeConstant('FETCH_GOOGLE_SCOPES')
export const FETCH_GOOGLE_SCOPES_PENDING = makeConstant('FETCH_GOOGLE_SCOPES_PENDING')
export const FETCH_GOOGLE_SCOPES_SUCCESS = makeConstant('FETCH_GOOGLE_SCOPES_SUCCESS')
export const FETCH_GOOGLE_SCOPES_FAILURE = makeConstant('FETCH_GOOGLE_SCOPES_FAILURE')

export const FETCH_MEETING_SETTINGS = makeConstant('FETCH_MEETING_SETTINGS')
export const FETCH_MEETING_SETTINGS_PENDING = makeConstant('FETCH_MEETING_SETTINGS_PENDING')
export const FETCH_MEETING_SETTINGS_SUCCESS = makeConstant('FETCH_MEETING_SETTINGS_SUCCESS')
export const FETCH_MEETING_SETTINGS_FAILURE = makeConstant('FETCH_MEETING_SETTINGS_FAILURE')

export const FETCH_MEETING_TYPES = makeConstant('FETCH_MEETING_TYPES')
export const FETCH_MEETING_TYPES_PENDING = makeConstant('FETCH_MEETING_TYPES_PENDING')
export const FETCH_MEETING_TYPES_SUCCESS = makeConstant('FETCH_MEETING_TYPES_SUCCESS')
export const FETCH_MEETING_TYPES_FAILURE = makeConstant('FETCH_MEETING_TYPES_FAILURE')

export const FETCH_CALENDLY_MEETING_TYPES = makeConstant('FETCH_CALENDLY_MEETING_TYPES')
export const FETCH_CALENDLY_MEETING_TYPES_PENDING = makeConstant('FETCH_CALENDLY_MEETING_TYPES_PENDING')
export const FETCH_CALENDLY_MEETING_TYPES_SUCCESS = makeConstant('FETCH_CALENDLY_MEETING_TYPES_SUCCESS')
export const FETCH_CALENDLY_MEETING_TYPES_FAILURE = makeConstant('FETCH_CALENDLY_MEETING_TYPES_FAILURE')

export const UPDATE_MEETING_TYPE = makeConstant('UPDATE_MEETING_TYPE')
export const UPDATE_MEETING_TYPE_PENDING = makeConstant('UPDATE_MEETING_TYPE_PENDING')
export const UPDATE_MEETING_TYPE_SUCCESS = makeConstant('UPDATE_MEETING_TYPE_SUCCESS')
export const UPDATE_MEETING_TYPE_FAILURE = makeConstant('UPDATE_MEETING_TYPE_FAILURE')

export const DEBOUNCE_UPDATE_MEETING_SETTINGS = makeConstant('DEBOUNCE_UPDATE_MEETING_SETTINGS')
export const UPDATE_MEETING_SETTINGS = makeConstant('UPDATE_MEETING_SETTINGS')
export const UPDATE_MEETING_SETTINGS_PENDING = makeConstant('UPDATE_MEETING_SETTINGS_PENDING')
export const UPDATE_MEETING_SETTINGS_SUCCESS = makeConstant('UPDATE_MEETING_SETTINGS_SUCCESS')
export const UPDATE_MEETING_SETTINGS_FAILURE = makeConstant('UPDATE_MEETING_SETTINGS_FAILURE')

export const DELETE_MEETING_TYPE = makeConstant('DELETE_MEETING_TYPE')
export const DELETE_MEETING_TYPE_PENDING = makeConstant('DELETE_MEETING_TYPE_PENDING')
export const DELETE_MEETING_TYPE_SUCCESS = makeConstant('DELETE_MEETING_TYPE_SUCCESS')
export const DELETE_MEETING_TYPE_FAILURE = makeConstant('DELETE_MEETING_TYPE_FAILURE')

export const UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS = makeConstant(
  'UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS'
)
export const UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING = makeConstant(
  'UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING'
)
export const UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS = makeConstant(
  'UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS'
)
export const UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE = makeConstant(
  'UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE'
)

export const SHARE_CALENDAR = makeConstant('SHARE_CALENDAR')
export const SHARE_CALENDAR_SUCCESS = makeConstant('SHARE_CALENDAR_SUCCESS')
export const SHARE_CALENDAR_FAILURE = makeConstant('SHARE_CALENDAR_FAILURE')

export const FETCH_CONNECTED_CALENDARS = makeConstant('FETCH_CONNECTED_CALENDARS')
export const FETCH_CONNECTED_CALENDARS_PENDING = makeConstant('FETCH_CONNECTED_CALENDARS_PENDING')
export const FETCH_CONNECTED_CALENDARS_SUCCESS = makeConstant('FETCH_CONNECTED_CALENDARS_SUCCESS')
export const FETCH_CONNECTED_CALENDARS_FAILURE = makeConstant('FETCH_CONNECTED_CALENDARS_FAILURE')

export const SHARE_ROUTED_CALENDAR = makeConstant('SHARE_ROUTED_CALENDAR')
export const SHARE_ROUTED_CALENDAR_SUCCESS = makeConstant('SHARE_ROUTED_CALENDAR_SUCCESS')
export const SHARE_ROUTED_CALENDAR_FAILURE = makeConstant('SHARE_ROUTED_CALENDAR_FAILURE')
export const SHARE_ROUTED_CALENDAR_PENDING = makeConstant('SHARE_ROUTED_CALENDAR_PENDING')

export const OPENED_MEETING_EMAIL_MODAL = makeConstant('OPENED_MEETING_EMAIL_MODAL')

export const MeetingSource = Object.freeze({
  CALENDAR_DROP: 'CALENDAR_DROP',
  EMAIL_DROP: 'EMAIL_DROP',
  PLAYBOOK_DROP: 'PLAYBOOK_DROP',
  PROFILE_DROP: 'PROFILE_DROP',
  PROFILE_LINK: 'PROFILE_LINK',
  RESCHEDULE: 'RESCHEDULE',
  SEQUENCE_DROP: 'SEQUENCE_DROP',
  NONE: 'NONE'
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/meetings/constants.js